/**
 * The seven Gate 1 trust attributes — single frontend source of truth.
 *
 * Mirrors backend/src/controllers/gate1Shared.js. The keys here are the wire
 * values (what the API stores in trust_attribute / attribute columns and what
 * the trust-weights LLM emits); TRUST_ATTRIBUTE_LABELS holds what a person
 * should ever see. Two of the seven differ between the two — FairnessPolicy
 * and HumanControl — so never render a raw key.
 */

export const TRUST_ATTRIBUTES = [
  "Reliability",
  "Safety",
  "Explainability",
  "Security",
  "Privacy",
  "FairnessPolicy",
  "HumanControl",
];

export const TRUST_ATTRIBUTE_LABELS = Object.freeze({
  Reliability: "Reliability",
  Safety: "Safety",
  Explainability: "Explainability",
  Security: "Security",
  Privacy: "Privacy",
  FairnessPolicy: "Fairness & Policy",
  HumanControl: "Human Control",
});

/** Short "what does this attribute cover" copy for the Step 1 slider rows. */
export const TRUST_ATTRIBUTE_DESCRIPTIONS = Object.freeze({
  Reliability:
    "Keeps outputs correct, grounded and stable over time — the foundation the other six rest on.",
  Safety:
    "Prevents harmful, toxic or unsafe outputs and the downstream actions they could trigger.",
  Explainability:
    "Keeps decisions understandable, traceable and defensible to reviewers and auditors.",
  Security:
    "Protects the system against prompt injection, unauthorized access and exploitation.",
  Privacy:
    "Prevents leakage of PII and sensitive data, and enforces retention and sharing limits.",
  FairnessPolicy:
    "Prevents biased outcomes across user cohorts and enforces the stated compliance policy.",
  HumanControl:
    "Keeps a human in the loop over autonomous actions, with oversight checkpoints and reversibility.",
});

export function trustAttributeLabel(key) {
  return TRUST_ATTRIBUTE_LABELS[key] || String(key ?? "");
}

/** Every attribute at 0 — the pre-generation baseline. */
export const ZERO_TRUST_WEIGHTS = Object.freeze(
  TRUST_ATTRIBUTES.reduce((acc, key) => ({ ...acc, [key]: 0 }), {})
);
